<script lang="ts">
	import { getShopPresentation } from '$lib/shop/presentation.svelte';

	const presentation = getShopPresentation();
</script>

{#if presentation.business && presentation.ready}
	<span class="shop-vat-label"
		>{presentation.vat === 'included'
			? presentation.labels.vatIncludedSuffix
			: presentation.labels.vatExcludedSuffix}</span
	>
{/if}

<style>
	.shop-vat-label {
		display: block;
		font-size: var(--font-size-0);
		align-self: flex-end;
	}
</style>
